import { render, staticRenderFns } from "./firstmileridermapping.vue?vue&type=template&id=3922add1&"
import script from "./firstmileridermapping.vue?vue&type=script&lang=js&"
export * from "./firstmileridermapping.vue?vue&type=script&lang=js&"
import style0 from "./firstmileridermapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports